export default {
  nav: {
    cta: 'Contact',
    contact: 'Contact'
  },
  hero: {
    headline: 'Wij maken jouw\n<em>verplichtingen</em> helder.',
    lede: 'Orchestratio is een Nederlands regulatory technology-bedrijf.<br>Wij bouwen de datalaag achter regelgeving —<br>het platform om te <em>ontdekken</em>, <em>organiseren</em> en <em>vragen</em> wat van toepassing is.',
    stat1num: '22k+',
    stat1label: 'Wetten',
    stat2num: 'NL & EU',
    stat2label: 'Regelgeving',
    stat3num: '2025',
    stat3label: 'Opgericht',
    workingOn: 'Wij werken aan:'
  },
  contact: {
    eyebrow: 'Neem contact op',
    title: 'Contact.',
    lede: 'Heb je een vraag, idee of voorstel? Laat een bericht achter en we nemen contact op.',
    companyDetails: 'Bedrijfsgegevens',
    legalName: 'Statutaire naam',
    tradingNames: 'Handelsnamen',
    address: 'Adres',
    country: 'Nederland',
    vat: 'BTW',
    sendMessage: 'Stuur een bericht',
    name: {
      label: 'Je naam',
      placeholder: 'Jan Jansen'
    },
    email: {
      label: 'Je e-mailadres',
      placeholder: 'jan@voorbeeld.nl'
    },
    message: {
      label: 'Bericht',
      placeholder: 'Schrijf hier je bericht...'
    },
    submit: 'Verstuur bericht',
    submitting: 'Verzenden...',
    success: {
      title: 'Bedankt voor je bericht',
      text: 'We hebben je bericht ontvangen en je ontvangt een bevestiging per e-mail. We proberen zo snel mogelijk te reageren.',
      back: 'Terug naar home'
    },
    error: {
      name: 'Vul je naam in.',
      email: 'Vul je e-mailadres in.',
      emailInvalid: 'Vul een geldig e-mailadres in.',
      message: 'Schrijf een bericht.',
      submit: 'Er ging iets mis. Probeer het later opnieuw.'
    }
  },
  notfound: {
    eyebrow: '404',
    title: 'Verdwaald in de ruimte.',
    lede: 'Deze pagina lijkt uit koers geraakt. Laten we je terugbrengen.',
    backHome: 'Terug naar home'
  },
  meta: {
    home: {
      title: 'Orchestratio — Wij maken jouw verplichtingen helder',
      description: 'Orchestratio is een Nederlands regulatory technology-bedrijf. Wij bouwen de datalaag achter regelgeving — het platform om te ontdekken, organiseren en vragen wat van toepassing is.'
    },
    contact: {
      title: 'Contact opnemen — Orchestratio',
      description: 'Neem contact op met Orchestratio. Vragen over regulatory technology, verplichtingen of ons platform? Stuur ons een bericht.'
    },
    notfound: {
      title: '404 — Orchestratio',
      description: 'Pagina niet gevonden.'
    }
  },
  footer: {
    copyright: '© 2026 Orchestratio B.V.',
    contact: 'Contact'
  }
}
